/*
 * @Descripttion: 获取微信登录code
 * @FilePath: /mall-wap-vue/src/utils/wechat.js
 * @Author: 张兴业
 * @Date: 2020-09-27 11:01:27
 * @LastEditors: 张兴业
 * @LastEditTime: 2021-11-29 11:48:16
 */
import { v1 as uuidv1 } from "uuid";
import { $G } from "@/global";
// const appid = "wxd9415fe8da6085d7"; // 杭州金蚁
// const appid = "wxc59971a11674ac9a"; // 沈阳金蚁
const appid = "wx0aa751f873923a04"; // 杭州火火龙
const guid = uuidv1();
const response_type = "code&scope=snsapi_userinfo";

function wechat() {
  const origin = $G("https://wap.myazstore.com");
  const { href } = window.location;
  const redirect_uri = encodeURIComponent(`${href}#${guid}`); // 是否需要传递guid  暂时未想好
  const url = `${origin}/wechatauth.html?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${response_type}&state=${guid}`;
  window.location.replace(url);
}

export default wechat;
